import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DefaultTabsBorderedBottom from './component/DefaultTabsBorderedBottom';

const Restaurant = () => (
  // <Container>
  <div>
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
      marginBottom: '5px',
    }}
    >
      <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
      <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
      <Typography sx={{ color: 'text.primary' }}>Search</Typography>
    </Breadcrumbs>
    <Row>
      <DefaultTabsBorderedBottom />
    </Row>
  </div>
 
  // </Container>
  );
export default Restaurant;
